// Module
var code = "<!-- ko with: _model --> <!-- ko if: PossibleToExample --> <label class=\"flex items-center gap-2.5\"> <input type=\"checkbox\" class=\"sps-switch sps-switch-sm\" data-bind=\"checked: ExampleSelected\"> <span class=\"sps-label\"><!-- ko text: $parent._labels.MAKE_EXAMPLE --><!-- /ko --></span> </label> <!-- /ko --> <!-- /ko -->";
// Exports
export default code;